import { Tooltip } from "antd";
import { GetAntIcon } from "../utils/ant_icons";

export const noSubscriptionMessage =
	"Subscription required. Please contact administrator.";

interface LockedModuleTooltipProps {
	children: React.ReactNode;
}

function LockedModuleTooltip({ children }: LockedModuleTooltipProps) {
	return (
		<Tooltip title={noSubscriptionMessage} placement={"right"}>
			<div
				style={{
					display: "flex",
					alignItems: "center",
					justifyContent: "space-between",
				}}
			>
				{children}
				<span>{GetAntIcon("lock")}</span>
			</div>
		</Tooltip>
	);
}

export default LockedModuleTooltip;
